/**
 * BT Header — side mobile menu drawer: close via backdrop or header close button.
 */
(() => {
  const closeDrawer = (mainMenu) => {
    const toggle = mainMenu?.querySelector('.main-menu__toggle');
    const content = mainMenu?.querySelector('.main-menu__content');
    if (toggle && content?.classList.contains('is-open')) {
      toggle.click();
    }
  };

  document.addEventListener('click', (evt) => {
    const closeBtn = evt.target.closest('.js-bt-mobile-menu-close');
    if (closeBtn) {
      const mainMenu = closeBtn.closest('main-menu.main-menu--side-drawer');
      if (mainMenu) {
        evt.preventDefault();
        closeDrawer(mainMenu);
      }
      return;
    }

    const backdrop = evt.target.closest('.bt-mobile-menu-backdrop');
    if (!backdrop) return;
    closeDrawer(backdrop.closest('main-menu.main-menu--side-drawer'));
  });
})();
